import { get } from 'lodash-es';

export enum CommonServer {
  police = 'police',
}

export default new (class StaticConfig {
  config: Record<string, any>;

  constructor() {
    this.config = window?.GLOBAL_CONFIG ?? {};
  }

  getRawConfig() {
    return this.config;
  }

  getConfig(path: string, defaultValue = '') {
    return get(this.config, path, defaultValue);
  }

  getCommonServer(path = 'commonServer', defaultValue = '') {
    return this.getConfig(`COMMON_SERVERS.${path}`, defaultValue);
  }

  getCoursesServer() {
    return this.getCommonServer('courses');
  }

  getMobileShopServer() {
    return this.getCommonServer('mobileShop');
  }

  getLiveRoomPrefix() {
    return this.getConfig('liveRoomPrefix', '');
  }

  // eslint-disable-next-line class-methods-use-this
  getPaypalClientId() {
    return window.GLOBAL_CONFIG.mobileShop.paypal.clientId;
  }
})();
